<template lang='pug' src='./docs-tabcontent.pug'></template>

<script>
export default {
  props: ['content']
}
</script>



// WEBPACK FOOTER //
// docs-tabcontent.vue?ab02cd62